/**
 * Enum representing features available for the clinic (RD/DA/SR/WM/MUFBG/MUFSK and IVOs)
 * thoses features are retrieved from the relations inside the okta JWT access token
 * and then merged in each clinics in the NGRX store
 */
export enum NewClinicFeature {
  DA = 'VS_DA',
  RD = 'VS_RD',
  WM = 'VS_WM',
  SR = 'VS_SR',
  MUF_PB = 'VS_MUF_PB',
  MUF_SK = 'VS_MUF_SK',
}

// TODO #339837 remove ClinicFeature and AppFeature and rename NewClinicFeature to ClinicFeature
/**
 * Enum representing features present in clinic.features
 * mostly used for market feature toggle
 * values are matching backend values
 * they should not be changed
 */
export enum ClinicFeature {
  DA = 'daily_allowance',
  RD = 'renal_detect',
  WM = 'weight_management',
  SR = 'smart_reco',
  MUF = 'muf',
}
/**
 * Enum representing features not present in clinic.features
 * mostly used for market feature toggle
 * Values are app scoped
 * they can be changed
 */
export enum AppFeature {
  MUF_SK = 'muf_starter_kits',
  MUF_PB = 'muf_personalized_bags',
}
